import {useState} from "react";

export const useHasJWT = () => {
    const [accessToken] = useState(localStorage.getItem('cobe-accessToken'));
    const hasJWT = () => localStorage.getItem('cobe-accessToken') !== null;
    return {hasJWT, accessToken};
}
